export default __webpack_public_path__ + "assets/ee17f6b9c5a8f7ef42f968840ed02a1c.jpg";